<template>
  <page-view id="login-view">
    <div class="sixteen wide device twelve wide tablet four wide computer centered column">
      <h3 class="ui centered header">
        {{ $t('login.header') }}
      </h3>
      <form
        @submit.prevent="submitCredentials"
        class="ui form">
        <div class="field">
          <label>{{ $t('login.mbEmail') }}</label>
          <input
            type="email"
            v-model="email"
            :placeholder="$t('login.mbEmail')"
            required="true">
        </div>
        <div class="field">
          <label>{{ $t('login.mbPassword') }}</label>
          <input
            type="password"
            v-model="password"
            :placeholder="$t('login.mbPassword')"
            required="true">
        </div>
        <button
          type="submit"
          :disabled="isLoading"
          :class="{ loading: isLoading }"
          class="ui fluid primary button">
          {{ $t('login.button') }}
        </button>
      </form>
      <message :message="message"/>
    </div>
  </page-view>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import { getCoaches } from '../forms/fields'
import { deleteAllCookies } from '../mixins/cookies'

export default {
  name: 'LoginPage',
  data () {
    return {
      isLoading: false,
      email: '',
      password: '',
      message: {
        text: '',
        class: ''
      }
    }
  },
  computed: {
    ...mapState(['userAuthToken'])
  },
  methods: {
    ...mapMutations(['setUser', 'resetStore']),
    ...mapActions(['saveCoaches']),

    submitCredentials () {
      this.login()
        .then(this.saveCredentialsToStoreAndCookies)
        .then(this.checkIsCoachOrIsAdmin)
        .then(this.saveCredentialsToStoreAndCookies)
        .then(this.saveCoaches)
        .catch(this.handleLoginErrors)
        .finally(() => { this.isLoading = false })
    },
    // // NOTE: Original Log In Logic
    // submitCredentials () {
    //   this.isLoading = true
    //   this.message = { text: '', class: '' }
    //
    //   let requestUrl = `${process.env.VUE_APP_API_URL}/login`
    //
    //   let body = {
    //     'appId': 'migraine-ios',
    //     email: this.email,
    //     password: this.password
    //   }
    //
    //   this.$axios.post(requestUrl, body)
    //     .then(
    //       ({ data }) => {
    //         let user = {
    //           userId: data.result.user.id,
    //           userEmail: data.result.user.email,
    //           userAuthToken: data.result.authenticationToken
    //         }
    //
    //         // cookies expire after 14 days
    //         let expiryDate = new Date()
    //         expiryDate.setDate(expiryDate.getDate() + 14)
    //
    //         document.cookie = `migraineCare_xiG1Zg2MW5_UserId=${user.userId}; expires=${expiryDate.toUTCString()}`
    //         document.cookie = `migraineCare_xiG1Zg2MW5_UserEmail=${user.userEmail}; expires=${expiryDate.toUTCString()}`
    //         document.cookie = `migraineCare_xiG1Zg2MW5_UserAuthToken=${user.userAuthToken}; expires=${expiryDate.toUTCString()}`
    //         document.cookie = `migraineCare_xiG1Zg2MW5_UserIsCoachOrAdmin=; expires=${new Date(0)}`
    //
    //         this.setUser(user)
    //       },
    //       ({ response }) => {
    //         if (response.status === 401) {
    //           this.message = { text: this.$t('login.wrongCredentials'), class: 'error' }
    //         } else {
    //           this.$rollbar.error('Error authenticating:', response)
    //         }
    //       }
    //     )
    //     .then(() => { this.isLoading = false })
    // },
    login () {
      return new Promise(
        (resolve, reject) => {
          this.isLoading = true
          this.message = { text: '', class: '' }

          let requestUrl = `${process.env.VUE_APP_API_URL}/login`

          let body = {
            appId: 'migraine-ios',
            email: this.email,
            password: this.password
          }

          this.$axios.post(requestUrl, body)
            .then(
              ({ data }) => {
                resolve(data.result)
              },
              ({ response }) => {
                reject(response)
              }
            )
        }
      )
    },
    checkIsCoachOrIsAdmin ({ authenticationToken, user }) {
      return new Promise(
        async (resolve, reject) => {
          let coaches = await (
            getCoaches()
              .catch(
                error => {
                  this.$rollbar.info('Attempt by user who is not a coach or administrator to log in to back office', error.response)
                  reject(new Error('Error fetching program coaches'))
                }
              )
          )

          let isAdmin = Array.isArray(user.currentRoles) && user.currentRoles.includes('ADMIN')
          let isCoach = (coaches || []).map(coach => coach.userId).includes(user.id)

          if (isCoach || isAdmin) {
            resolve({ authenticationToken, user: user, userIsCoachOrAdmin: true, coaches })
          } else {
            reject(new Error('User is not a program coach or an administrator'))
          }
        }
      )
    },
    saveCredentialsToStoreAndCookies ({ authenticationToken, user, userIsCoachOrAdmin = false, coaches }) {
      return new Promise(
        resolve => {
          let credentials = {
            userId: user.id,
            userEmail: user.email,
            userAuthToken: authenticationToken,
            userIsCoachOrAdmin: userIsCoachOrAdmin
          }

          // Cookies expire after 14 days
          let expiryDate = new Date()
          expiryDate.setDate(expiryDate.getDate() + 14)

          document.cookie = `migraineCare_xiG1Zg2MW5_UserId=${credentials.userId}; expires=${expiryDate.toUTCString()}`
          document.cookie = `migraineCare_xiG1Zg2MW5_UserEmail=${credentials.userEmail}; expires=${expiryDate.toUTCString()}`
          document.cookie = `migraineCare_xiG1Zg2MW5_UserAuthToken=${credentials.userAuthToken}; expires=${expiryDate.toUTCString()}`
          document.cookie = `migraineCare_xiG1Zg2MW5_UserIsCoachOrAdmin=${credentials.userIsCoachOrAdmin}; expires=${expiryDate.toUTCString()}`

          this.setUser(credentials)

          resolve({ authenticationToken, user, userIsCoachOrAdmin, coaches })
        }
      )
    },
    handleLoginErrors (error) {
      return new Promise(
        resolve => {
          if (error instanceof Error) {
            switch (error.message) {
              case 'User is not a program coach or an administrator':
                this.message = { text: this.$t('login.notCoachAccount'), class: 'error' }
                break
              case 'Error fetching program coaches':
                this.message = { text: this.$t('login.unableToFetchCoaches'), class: 'error' }
                break
              default:
                this.message = { text: this.$t('login.unknownError'), class: 'error' }
            }
          } else if (error.status === 401) {
            this.message = { text: this.$t('login.wrongCredentials'), class: 'error' }
          } else {
            this.$rollbar.error('Unable to authenticate', error)
          }

          deleteAllCookies()
          this.resetStore()

          resolve()
        }
      )
    }
  }
}
</script>
